import React, { useEffect } from "react";
import { Field, useFormikContext } from "formik";
import Select from "react-select";
import "./AddCaseProcedure.scss";
import { useState } from "react";
import SuggestionBoxUtil from "../../../utils/SuggestionBoxUtil";
import { CaseServices } from "../../../services/CaseServices";
import { handleApiErrorResponses } from "../../../utils/ApisErrorHandling";
import { HospitalServices } from "../../../services/HospitalServices";
import EditProcedure from "./EditProcedure";
import EditIcon from "../../../assets/editIcon.svg";
import DeleteIcon from "../../../assets/deleteIcon.svg";
import ICHISelect from "../../../ICD/IchiSelect";
import ScreenshotWithChat from "./ScreenshotWithChat";
import { Close } from "@mui/icons-material";
import { CommentServices } from "../../../services/CommentServices";
const AddCaseProcedure = ({
  errors,
  touched,
  index,
  procdure,
  patientDetails,
  values,
  remove,
  addProcedure,
  hospitalState,
  caseDetails,
}) => {
  let staratificationEnums = [
    "ICUWITHVENTILATOR",
    "ICUWITHOUTVENTILATOR",
    "HDU",
    "GENERALWARD",
  ];
  const [selectedProcedureId, setSelectedProcedureId] = useState(null);
  const [compositId, setCompositId] = useState(
    procdure?.compositId ? procdure.compositId : null,
  );
  const [doctorList, setDoctorList] = useState([]);
  const [implants, setImplants] = useState([]);
  const [tierCost, setTierCost] = useState(null);
  const [packageCost, setPackageCost] = useState(null);
  const [riskData, setRiskData] = useState(null);
  const [procedureInputValue, setProcedureInputValue] = useState(null);
  const [specialityInputValue, setSpecialityInputValue] = useState(null);
  const [doctorName, setDoctorName] = useState(procdure.doctorName);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isScreenshotOpen, setIsScreenshotOpen] = useState(false);
  const { setFieldValue } = useFormikContext();
  const handleStratificationChange = (event, newValue) => {
    setFieldValue(`caseProcedures.${index}.stratification`, newValue);
  };
  // console.log("values:", values);
  const handleAutoSuggestion = (selected, e) => {
    console.log("selected", selected);
    if (!selected) return;

    setFieldValue(`caseProcedures.${index}.${e.name}`, selected.value);

    if (e.name === "procedure") {
      setFieldValue(
        `caseProcedures.${index}.procedureId`,
        selected.procedureId,
      );
      setFieldValue(`caseProcedures.${index}.compositId`, selected.id);
      setCompositId(selected.id);
      setSelectedProcedureId(selected.procedureId);
    } else if (e.name === "speciality") {
      setFieldValue(
        `caseProcedures.${index}.specialityId`,
        selected.specialityId,
      );
    }
  };
  const defaultRisks = async () => {
    try {
      const res = await CommentServices.getDefaultRisks();
      setRiskData(res?.data?.list);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  // const getProcedureCostList = async () => {
  //   try {
  //     const response = await CaseServices.getProcedureCostList(
  //       compositId,
  //       patientDetails.city,
  //     );
  //     setFieldValue("tier", response?.data?.procedureCost?.tier);
  //     if (response?.data?.procedureCost?.implants) {
  //       setImplants(response?.data?.procedureCost?.implants);
  //       if (response?.data?.procedureCost?.implants?.length > 0) {
  //         setFieldValue(
  //           `caseProcedures.${index}.availableImplants`,
  //           response?.data?.procedureCost?.implants,
  //         );
  //       } else {
  //         setFieldValue(`caseProcedures.${index}.implants`, "");
  //         setFieldValue(`caseProcedures.${index}.availableImplants`, []);
  //       }
  //     } else {
  //       setImplants([]);
  //       setFieldValue(`caseProcedures.${index}.availableImplants`, []);
  //       setFieldValue(`caseProcedures.${index}.implants`, "");
  //     }
  //     if (Array.isArray(response?.data?.procedureCost?.tierCost)) {
  //       setTierCost(response?.data?.procedureCost?.tierCost);
  //       setPackageCost(null);
  //     } else {
  //       setTierCost(null);
  //       setFieldValue(
  //         `caseProcedures.${index}.packageCost`,
  //         response?.data?.procedureCost?.tierCost,
  //       );

  //       setPackageCost(response?.data?.procedureCost?.tierCost);

  //       //  Reset stratification when backend sends no stratification list
  //       setFieldValue(`caseProcedures.${index}.stratification`, "");
  //     }
  //   } catch (error) {
  //     handleApiErrorResponses(error);
  //   }
  // };
  // const getProcedureCostList = async () => {
  //   try {
  //     const response = await CaseServices.getProcedureCostList(
  //       compositId,
  //       patientDetails.city,
  //     );
  //     setFieldValue("tier", response?.data?.procedureCost?.tier);

  //     const fetchedImplants = response?.data?.procedureCost?.implants;

  //     if (fetchedImplants && fetchedImplants.length > 0) {
  //       setImplants(fetchedImplants);
  //       setFieldValue(
  //         `caseProcedures.${index}.availableImplants`,
  //         fetchedImplants,
  //       );
  //     } else {
  //       setImplants([]);
  //       setFieldValue(`caseProcedures.${index}.availableImplants`, []);
  //       setFieldValue(`caseProcedures.${index}.implants`, "");
  //     }

  //     if (Array.isArray(response?.data?.procedureCost?.tierCost)) {
  //       setTierCost(response?.data?.procedureCost?.tierCost);
  //       setPackageCost(null);
  //     } else {
  //       const baseApiCost = response?.data?.procedureCost?.tierCost;

  //       // If this procedure already has a saved implant, add its price
  //       // so packageCost reflects the true cost (base + implant)
  //       const savedImplantName = procdure?.implants;
  //       const matchedImplant =
  //         fetchedImplants && savedImplantName
  //           ? fetchedImplants.find((imp) => imp.name === savedImplantName)
  //           : null;

  //       const effectiveCost = matchedImplant
  //         ? Number(baseApiCost) + Number(matchedImplant.price)
  //         : Number(baseApiCost);

  //       setTierCost(null);

  //       // Only update Formik packageCost if it differs from what's already saved
  //       // (avoids overwriting correct DB value with stale API base cost)
  //       setFieldValue(`caseProcedures.${index}.packageCost`, effectiveCost);
  //       setPackageCost(effectiveCost); // triggers totalPackageCost recalc
  //       setFieldValue(`caseProcedures.${index}.stratification`, "");
  //     }
  //   } catch (error) {
  //     handleApiErrorResponses(error);
  //   }
  // };

  // const getProcedureCostList = async () => {
  //   try {
  //     const response = await CaseServices.getProcedureCostList(
  //       compositId,
  //       patientDetails.city,
  //     );
  //     setFieldValue("tier", response?.data?.procedureCost?.tier);
  //     if (response?.data?.procedureCost?.implants) {
  //       setImplants(response?.data?.procedureCost?.implants);
  //       if (response?.data?.procedureCost?.implants?.length > 0) {
  //         setFieldValue(
  //           `caseProcedures.${index}.availableImplants`,
  //           response?.data?.procedureCost?.implants,
  //         );
  //       } else {
  //         setFieldValue(`caseProcedures.${index}.implants`, "");
  //         setFieldValue(`caseProcedures.${index}.availableImplants`, []);
  //       }
  //     } else {
  //       setImplants([]);
  //       setFieldValue(`caseProcedures.${index}.availableImplants`, []);
  //       setFieldValue(`caseProcedures.${index}.implants`, "");
  //     }
  //     if (Array.isArray(response?.data?.procedureCost?.tierCost)) {
  //       setTierCost(response?.data?.procedureCost?.tierCost);
  //       setPackageCost(null);
  //     } else {
  //       const baseApiCost = response?.data?.procedureCost?.tierCost;

  //       // ✅ KEY FIX: If editing an existing procedure that already has a
  //       // saved packageCost, preserve it — don't overwrite with recalculated value
  //       const existingPackageCost = procdure?.packageCost;
  //       const isExistingProcedure = !!procdure?.id; // has a DB id = already saved

  //       if (isExistingProcedure && existingPackageCost) {
  //         // Just set local state for UI/totalPackageCost recalc triggers,
  //         // but don't overwrite the saved Formik value
  //         setTierCost(null);
  //         setPackageCost(Number(existingPackageCost));
  //         // Keep the Formik value as-is (already initialized from DB)
  //       } else {
  //         // New procedure being added — calculate fresh
  //         const savedImplantName = procdure?.implants;
  //         const matchedImplant =
  //           fetchedImplants && savedImplantName
  //             ? fetchedImplants.find((imp) => imp.name === savedImplantName)
  //             : null;

  //         const effectiveCost = matchedImplant
  //           ? Number(baseApiCost) + Number(matchedImplant.price)
  //           : Number(baseApiCost);

  //         setTierCost(null);
  //         setFieldValue(`caseProcedures.${index}.packageCost`, effectiveCost);
  //         setPackageCost(effectiveCost);
  //         setFieldValue(`caseProcedures.${index}.stratification`, "");
  //       }
  //     }
  //   } catch (error) {
  //     handleApiErrorResponses(error);
  //   }
  // };
  const getProcedureCostList = async () => {
    try {
      const response = await CaseServices.getProcedureCostList(
        compositId,
        patientDetails.city,
      );
      setFieldValue("tier", response?.data?.procedureCost?.tier);

      const fetchedImplants = response?.data?.procedureCost?.implants;

      if (fetchedImplants && fetchedImplants.length > 0) {
        setImplants(fetchedImplants);
        setFieldValue(
          `caseProcedures.${index}.availableImplants`,
          fetchedImplants,
        );
      } else {
        setImplants([]);
        setFieldValue(`caseProcedures.${index}.availableImplants`, []);
        setFieldValue(`caseProcedures.${index}.implants`, "");
      }

      if (Array.isArray(response?.data?.procedureCost?.tierCost)) {
        setTierCost(response?.data?.procedureCost?.tierCost);
        setPackageCost(null);
      } else {
        const baseApiCost = response?.data?.procedureCost?.tierCost;

        // const existingPackageCost = procdure?.packageCost;
        const existingPackageCost =
          caseDetails?.caseprocedures[index]?.packageCost;
        const isExistingProcedure =
          caseDetails?.caseprocedures[index]?.procedureId ===
          values?.caseProcedures[index]?.procedureId; // has a DB id = already saved
        if (isExistingProcedure && existingPackageCost) {
          setTierCost(null);
          setPackageCost(Number(existingPackageCost));
          setFieldValue(
            `caseProcedures.${index}.packageCost`,
            Number(existingPackageCost),
          );
        } else {
          const savedImplantName = procdure?.implants;
          const matchedImplant =
            fetchedImplants && savedImplantName
              ? fetchedImplants.find((imp) => imp.name === savedImplantName)
              : null;

          const effectiveCost = matchedImplant
            ? Number(baseApiCost) + Number(matchedImplant.price)
            : Number(baseApiCost);

          setTierCost(null);
          setFieldValue(`caseProcedures.${index}.packageCost`, effectiveCost);
          setPackageCost(effectiveCost);
          setFieldValue(`caseProcedures.${index}.stratification`, "");
        }
      }
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const getDoctorList = async () => {
    try {
      const response = await HospitalServices.getDoctorList(
        "",
        1,
        40,
        patientDetails.hospitalId,
      );
      setDoctorList(response.data.list);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  useEffect(() => {
    getDoctorList();
    defaultRisks();
  }, []);
  useEffect(() => {
    if (compositId) {
      getProcedureCostList();
    }
  }, [compositId]);
  useEffect(() => {
    if (packageCost) {
      // const totalCost = values?.caseProcedures?.reduce(
      //   (accumulator, currentValue) =>
      //     Number(accumulator) + Number(currentValue.packageCost),
      //   0,
      // );
      // setFieldValue("totalPackageCost", totalCost);
      let initialEnhancementCost = 0;
      const prevTotalCost = caseDetails?.caseprocedures
        .map((item) => Number(item.packageCost) || 0)
        .sort((a, b) => b - a)
        .reduce((total, cost, index) => {
          if (index === 0) return total + cost;
          return total + cost * (index === 1 ? 0.5 : 0.25);
        }, 0);
      initialEnhancementCost = caseDetails?.totalPackageCost - prevTotalCost;

      const newTotalCost = values?.caseProcedures
        .map((item) => Number(item.packageCost) || 0)
        .sort((a, b) => b - a)
        .reduce((total, cost, index) => {
          if (index === 0) return total + cost;
          return total + cost * (index === 1 ? 0.5 : 0.25);
        }, 0);

      // console.log(newTotalCost);
      setFieldValue("totalPackageCost", newTotalCost);
    }
  }, [packageCost]);

  return (
    <div className="add-case-procedure-container">
      <div className="flex justify-between items-center">
        <div className="sub-heading">
          Procedure {index + 1 > 0 ? index + 1 : ""}
        </div>

        <div
          style={{ border: "1px solid #017C57" }}
          className="flex gap-2 text-[#017C57] items-center h-fit py-1 xl:py-2 px-5 rounded-full cursor-pointer"
          onClick={() => setIsEditOpen(true)}
        >
          <div>
            <img src={EditIcon} alt="edit-icon" />
          </div>{" "}
          Edit
        </div>

        {values?.caseProcedures?.length > 1 &&
          !values?.caseProcedures[index]?.id && (
            <div
              className="ml-2 cursor-pointer"
              onClick={() => {
                remove(index);

                const totalCost = values?.caseProcedures
                  ?.filter((_, idx) => index != idx)
                  .reduce(
                    (accumulator, currentValue) =>
                      Number(accumulator) + Number(currentValue.packageCost),
                    0,
                  );
                setFieldValue("totalPackageCost", totalCost);
              }}
            >
              <img src={DeleteIcon} alt="" />
            </div>
          )}
      </div>
      {isEditOpen && (
        <EditProcedure
          setIsEditOpen={setIsEditOpen}
          specialityParam={procdure.speciality}
          specialityIdParam={procdure.specialityId}
          procedureParam={procdure.procedure}
          procedureIdParam={procdure.procedureId}
          compositIdParam={procdure.compositId}
          type="EDIT"
        />
      )}

      <div className="case-form-container1 items-end">
        <label className="label1">
          <div className="text-content">Speciality *</div>
          <SuggestionBoxUtil
            className="input-field"
            api={CaseServices.defaultSpecialityList}
            selectedValue={procdure.speciality}
            name="speciality"
            handleChange={handleAutoSuggestion}
            setInputValue={setSpecialityInputValue}
            hospitalState={hospitalState}
            clearable={true}
          />
          {touched &&
            touched.caseProcedures &&
            touched.caseProcedures[`${index}`] &&
            touched.caseProcedures[`${index}`].speciality &&
            errors &&
            errors.caseProcedures &&
            errors?.caseProcedures[`${index}`]?.speciality && (
              <div className="field-error">
                {errors?.caseProcedures[`${index}`]?.speciality}
              </div>
            )}
        </label>
        <label className="label1">
          <div className="text-content">Procedure Id & Name *</div>
          <SuggestionBoxUtil
            className="input-field"
            searchParams={`${procdure.speciality}`}
            api={CaseServices.defaultProcedureNameList}
            selectedValue={procdure.procedure}
            name="procedure"
            handleChange={handleAutoSuggestion}
            setInputValue={setProcedureInputValue}
            hospitalState={hospitalState}
            selectedProcedures={
              values?.caseProcedures?.length > 0
                ? values?.caseProcedures
                : caseDetails?.caseprocedures?.length > 0
                  ? caseDetails?.caseprocedures
                  : []
            }
            clearable={true}
          />

          {touched &&
            touched.caseProcedures &&
            touched.caseProcedures[`${index}`] &&
            touched.caseProcedures[`${index}`].procedure &&
            errors &&
            errors.caseProcedures &&
            errors?.caseProcedures[`${index}`]?.procedure && (
              <div className="field-error">
                {errors?.caseProcedures[`${index}`]?.procedureId}
              </div>
            )}
        </label>

        <label className="label1">
          <div className="text-content">ICHI Code/Description</div>

          <ICHISelect
            onSelect={(selected) => {
              console.log("Selected ICHI code:", selected?.code);
              console.log("Full selected data:", selected?.full);
            }}
            description={
              values?.caseProcedures[index]?.procedure?.slice(7) || ""
            }
          />
        </label>
        {/* Showing stratification only when there is tier cost array */}
        {Array.isArray(tierCost) && (
          <label className="label1">
            <div className="text-content">Stratification</div>
            <Select
              options={tierCost}
              getOptionLabel={(options) => {
                return options["name"];
              }}
              getOptionValue={(options) => {
                return options["name"];
              }}
              placeholder="Select Stratification"
              value={tierCost.filter(
                (option) => option.name === procdure.stratification,
              )}
              onChange={(item) => {
                setPackageCost(item.price);
                // values.caseProcedures[`${index}`].packageCost
                //   ? setFieldValue(
                //       "totalPackageCost",
                //       Number(values.totalPackageCost) -
                //         Number(values.caseProcedures[`${index}`].packageCost) +
                //         Number(item.price)
                //     )
                //   : setFieldValue(
                //       "totalPackageCost",
                //       Number(values.totalPackageCost) + Number(item.price)
                //     );
                setFieldValue(
                  `caseProcedures.${index}.packageCost`,
                  Number(item.price),
                );

                setFieldValue(
                  `caseProcedures.${index}.stratification`,
                  item.name,
                );
              }}
            />
            {touched &&
              touched.caseProcedures &&
              touched.caseProcedures[`${index}`] &&
              touched.caseProcedures[`${index}`].stratification &&
              errors &&
              errors.caseProcedures &&
              errors?.caseProcedures[`${index}`]?.stratification && (
                <div className="field-error">
                  {errors?.caseProcedures[`${index}`]?.stratification}
                </div>
              )}
          </label>
        )}

        {implants && implants.length > 0 && (
          <label className="label1">
            <div className="text-content">Implants</div>

            <Select
              options={implants}
              getOptionLabel={(options) => {
                return options["name"] + "-" + options["price"];
              }}
              getOptionValue={(options) => {
                return options["price"];
              }}
              placeholder="Select Implants"
              onChange={(item) => {
                const prevImplant = implants?.filter(
                  (implant) =>
                    implant.name === values?.caseProcedures[index].implants,
                );

                let calculatedCost = 0;
                if (prevImplant?.length > 0) {
                  calculatedCost =
                    Number(values?.caseProcedures[index].packageCost) +
                    Number(item.price) -
                    Number(prevImplant[0].price);
                  // setFieldValue(
                  //   "totalPackageCost",
                  //   Number(values.totalPackageCost) +
                  //     Number(item.price) -
                  //     prevImplant[0].price,
                  // );
                } else {
                  calculatedCost =
                    Number(values?.caseProcedures[index].packageCost) +
                    Number(item.price);
                  // setFieldValue(
                  //   "totalPackageCost",
                  //   Number(values.totalPackageCost) + Number(item.price),
                  // );
                }
                setFieldValue(`caseProcedures.${index}.implants`, item.name);
                setFieldValue(
                  `caseProcedures.${index}.packageCost`,
                  calculatedCost,
                );
                setPackageCost(calculatedCost);
              }}
              value={implants?.filter(
                (option) => option?.name === procdure.implants,
              )}
            />

            {touched &&
              touched.caseProcedures &&
              touched.caseProcedures[`${index}`] &&
              touched.caseProcedures[`${index}`].implants &&
              errors &&
              errors.caseProcedures &&
              errors?.caseProcedures[`${index}`]?.implants && (
                <div className="field-error">
                  {errors?.caseProcedures[`${index}`]?.implants}
                </div>
              )}
          </label>
        )}
        <label className="label1">
          <div className="text-content">Package Cost *</div>
          <Field
            className="input-field"
            disabled
            name={`caseProcedures.${index}.packageCost`}
            placeholder="Package Cost"
          />
          {touched &&
            touched.caseProcedures &&
            touched.caseProcedures[`${index}`] &&
            touched.caseProcedures[`${index}`].packageCost &&
            errors &&
            errors.caseProcedures &&
            errors?.caseProcedures[`${index}`]?.packageCost && (
              <div className="field-error">
                {errors?.caseProcedures[`${index}`]?.packageCost}
              </div>
            )}
        </label>
        <label className="label1">
          <div className="text-content">Doctor Name </div>
          <Select
            options={doctorList}
            getOptionLabel={(options) => {
              return `${options["fullName"]}-${options["highestQualification"]}`;
            }}
            getOptionValue={(options) => {
              return options["id"];
            }}
            placeholder="Select Doctor"
            value={doctorList.filter((option) => {
              return option.fullName === doctorName;
            })}
            onChange={(item) => {
              setFieldValue(
                `caseProcedures.${index}.doctorName`,
                item.fullName,
              );
              setFieldValue(
                `caseProcedures.${index}.doctorId`,
                item.doctorhospitalmappings[0].doctorId,
              );
              setDoctorName(item.fullName);
            }}
          />
          {touched &&
            touched.caseProcedures &&
            touched.caseProcedures[`${index}`] &&
            touched.caseProcedures[`${index}`].doctorName &&
            errors &&
            errors.caseProcedures &&
            errors?.caseProcedures[`${index}`]?.doctorName && (
              <div className="field-error">
                {errors?.caseProcedures[`${index}`]?.doctorName}
              </div>
            )}
        </label>
        <label className="label1">
          <div className="text-content">Hospital State</div>
          <Field
            className="input-field"
            disabled
            name={`caseProcedures.${index}.state`}
            placeholder="Hospital State"
          />
          {/* {touched &&
            touched.caseProcedures &&
            touched.caseProcedures[`${index}`] &&
            touched.caseProcedures[`${index}`].packageCost &&
            errors &&
            errors.caseProcedures &&
            errors?.caseProcedures[`${index}`]?.packageCost && (
              <div className="field-error">
                {errors?.caseProcedures[`${index}`]?.packageCost}
              </div>
            )} */}
        </label>

        <div className="flex gap-3 items-center font-semibold">
          <input
            type="checkbox"
            id="hospitalProcedure"
            className="h-[24px] w-[24px]"
            // value={values?.caseProcedures[`${index}`]?.procedureFromHospital}
            checked={values?.caseProcedures[`${index}`]?.procedureFromHospital}
            onChange={() =>
              setFieldValue(
                `caseProcedures.${index}.procedureFromHospital`,
                !values?.caseProcedures[`${index}`]?.procedureFromHospital,
              )
            }
          />
          <label htmlFor="hospitalProcedure">Procedure From Hospital</label>
        </div>

        {values?.caseProcedures[`${index}`]?.procedureFromHospital && (
          <div className="w-full flex items-end justify-between">
            <label className="label1">
              <div className="text-content">Risk</div>
              <Select
                options={riskData}
                getOptionLabel={(options) => options["riskType"]}
                getOptionValue={(options) => options["riskType"]}
                placeholder="Select Risk"
                value={riskData?.filter(
                  (risk) =>
                    risk.riskType === values?.caseProcedures[index]?.risk,
                )}
                onChange={(item) => {
                  setFieldValue(`caseProcedures.${index}.risk`, item.riskType);
                  let newRiskData = {};
                  for (let i = 0; i < values?.caseProcedures.length; i++) {
                    if (i == index) {
                      newRiskData = { ...newRiskData, [item.riskType]: item };
                    } else {
                      if (values?.caseProcedures[i]?.risk) {
                        let riskValue = riskData?.filter(
                          (risk) =>
                            risk.riskType === values?.caseProcedures[i].risk,
                        );
                        newRiskData = {
                          ...newRiskData,
                          [values?.caseProcedures[i].risk]: riskValue[0],
                        };
                      }
                    }
                  }
                  setFieldValue("riskData", newRiskData);
                }}
              />
            </label>
            <label className="label1">
              <div className="text-content">Risk Loss</div>
              <Field
                className="input-field"
                name={`caseProcedures.${index}.riskLoss`}
                placeholder="Risk Loss"
              />
            </label>
            {values?.caseProcedures[`${index}`]?.procedureApprovalUrl ? (
              <div className="relative h-[150px] w-[150px]">
                <div
                  className="absolute top-1 right-1 cursor-pointer"
                  onClick={() => {
                    if (window.confirm("Do you want to remove this:")) {
                      setFieldValue(
                        `caseProcedures.${index}.procedureApprovalUrl`,
                        null,
                      );
                    }
                  }}
                >
                  <Close />
                </div>
                <a
                  href={
                    values?.caseProcedures[`${index}`]?.procedureApprovalUrl
                  }
                  target="_blank"
                >
                  <div className="h-[150px] w-[150px] p-1 border-2 border-black rounded-lg overflow-hidden bg-white">
                    <img
                      src={
                        values?.caseProcedures[`${index}`]?.procedureApprovalUrl
                      }
                      alt="screenshot"
                      className="h-full w-full object-contain"
                    />
                  </div>
                </a>
              </div>
            ) : (
              <button
                type="button"
                className="text-[#017c57] text-sm font-semibold h-fit bg-white border border-solid border-[#017C57] py-3 px-5 rounded-[8px] "
                onClick={() => setIsScreenshotOpen(true)}
              >
                Upload Screenshot of Chat
              </button>
            )}
          </div>
        )}

        {isScreenshotOpen && (
          <ScreenshotWithChat
            caseDetails={caseDetails}
            setIsScreenshotOpen={setIsScreenshotOpen}
            index={index}
          />
        )}
      </div>
    </div>
  );
};

export default AddCaseProcedure;
